import React from 'react'
import { Checkbox, Grid, Popup } from 'semantic-ui-react'

import './Field.scss'

const { Row, Column } = Grid

const BoolField = ({
  className,
  label,
  value,
  name,
  onChange,
  required,
  error,
  validated,
  tooltip,
  children,
  before,
  after,
  disabled,
}) => (
  <Row className={`field ${className}${required ? ' required' : ''}`}>
    <Column width={4} />
    <Column width={8}>
      {before}
      <Checkbox
        label={label}
        name={name}
        checked={value}
        disabled={disabled}
        onChange={() => onChange({ value: !value })}
        required={required || undefined}
        className="checkbox-label"
      />
      {after}
      {!!tooltip &&
        <Popup
          trigger={<i className="daicon daicon-Help tooltip" />}
          content={tooltip}
          position="right center"
        />

      }
    </Column>
    <Column width={4}>
      {!!error &&
        <Popup
          trigger={<i className="daicon daicon-Attention error" />}
          content={error}
          position="right center"
        />
      }

      {validated && !error &&
        <i className="daicon daicon-Checkmark success" />
      }

      {children}

    </Column>
  </Row>
)

BoolField.defaultProps = {
  className: '',
  value: false,
  validated: false,
  required: false,
  error: '',
  tooltip: '',
  children: null,
  before: null,
  after: null,
  disabled: false,
}

BoolField.propTypes = {
  className: React.PropTypes.string,
  label: React.PropTypes.string.isRequired,
  name: React.PropTypes.string.isRequired,
  value: React.PropTypes.bool,
  onChange: React.PropTypes.func.isRequired,
  validated: React.PropTypes.bool,
  disabled: React.PropTypes.bool,
  error: React.PropTypes.string,
  tooltip: React.PropTypes.string,
  required: React.PropTypes.bool,
  children: React.PropTypes.any,
  before: React.PropTypes.any,
  after: React.PropTypes.any,
}

export default BoolField



// WEBPACK FOOTER //
// ./src/browser/components/fields/Bool.js